import { createSelector } from 'reselect';
import get from 'lodash.get';

const getRouter = state => state.router;
const getConfig = state => get(state, 'config');

export const getCurrentLocation = createSelector(
  [getRouter],
  router => router.location,
);

export const getCurrentPoint = createSelector(
  [getRouter],
  router => router.location.pathname + (router.location.search || ''),
);

export const getIsVerboseOn = createSelector(getConfig, config =>
  get(config, 'isVerboseOn', false),
);

export const getBearerToken = createSelector(getConfig, config =>
  get(config, 'clients.libraryClient.token'),
);

export const getChallengesEntry = createSelector(getConfig, config =>
  get(config, 'challengesEntry', false),
);

export const getSearchInitiatedFrom = createSelector(getConfig, config =>
  get(config, 'searchInitiatedFrom', ''),
);

export const getUserId = createSelector(getConfig, config => config.userId);
